import React, { useEffect, useState } from 'react';
import Modal from '../../../layout/modal/Modal';
import styles from './LeadDetailsModal.module.scss';
import {
	CalendarToday,
	Videocam,
	InfoOutlined,
	Edit,
} from '@mui/icons-material';
import { Grid, IconButton } from '@material-ui/core';
import getSalesAgentById from '../../../../api/SalesAgents/getSalesAgentById.api';
import getCoBrokerByUserId from '../../../../api/Deals/getCoBrokerAssignedLots.api';
import { connect } from 'react-redux';
import { closeModal, openModal } from '../../../../redux/modals/action';
import { getAppointment, getLeadById } from '../../../../redux/deals/action';
import { useHistory } from 'react-router';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../../redux/confirmations/actions';
import ConfirmationComponent from '../../../confirmation/ConfirmationComponent';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CustomAlerts from '../../../alerts/CustomAlerts';
import StripeSection from '../../stripeIdentification/StripeSection';
import StripeProcessing from '../../stripeIdentification/StripeProcessing';
import MeetingStatus from '../../../meetingStatus/MeetingStatus';
import { convertLeadToPurchaser } from '../../../../redux/purchasers/actions';
import { resetAgreement } from '../../../../redux/agreement/actions';
import { reformatPhoneString2 } from '../../../../utils/validatePhoneNumber';
import { numberWithCommas } from '../../../../utils/numberWithCommas';

const LeadDetailsModal = ({
	//parent props
	showModal,
	lead,
	openVerificationModal,
	handleEditLead,
	// redux
	closeModal,
	openModal,
	getLeadById,
	confirmation, //
	setConfirmation,
	closeConfirmation,
	convertLeadToPurchaser,
	getAppointment,
	appointmentDetails,
	currentUserDetails,
	leadById,
	resetAgreement,
	purchasers,
	leads,
}) => {
	const [salesAgentName, setSalesAgentName] = useState();
	const [snackbar, setSnackbar] = useState(false);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [coBrokerInfo, setCoBrokerInfo] = useState({});
	const [togglIdentification, setTogglIdentification] = useState(true);

	const history = useHistory();

	useEffect(() => {
		getLeadById(lead?.leadsKey);
	}, [leads]);
	useEffect(() => {
		getAppointment(lead?.leadsKey);
		getLeadById(lead?.leadsKey);
	}, [lead?.leadsKey]);
	useEffect(() => {
		setTogglIdentification(true);
	}, [leadById]);

	useEffect(() => {
		getLeadById(lead?.leadsKey);
		lead &&
			getSalesAgentById(lead.salesAgent, (returned) => {
				setSalesAgentName(returned.fullName);
			});
	}, [lead]);
	useEffect(async () => {
		if (currentUserDetails.userType === 'cobroker') {
			let coBroker = await getCoBrokerByUserId(currentUserDetails.uid);
			setCoBrokerInfo(coBroker);
		}
	}, []);

	const handleStartAgreement = () => {
		setConfirmation('startAgreement');
		closeModal('leadDetails');
		resetAgreement();
	};

	const handleDiscard = () => {
		closeConfirmation('startAgreement');
	};

	const handleConfirm = () => {
		let identificationStatus = lead?.identification?.verification?.status;
		if (identificationStatus === 'requires_input') {
			closeConfirmation('startAgreement');
			setSnackbar(true);
			setSnackbarMessage(
				'You cannot convert a client who is in identification process. Please try again after the client finishes verifiation process or cancel the identification'
			);
			setTimeout(() => {
				setSnackbar(false);
			}, 4000);
		} else if (!validateCoBrokerNumOfLots()) {
			closeConfirmation('startAgreement');
			setSnackbar(true);
			setSnackbarMessage(
				'This coBroker is not allowed to create more deals.'
			);
			setTimeout(() => {
				setSnackbar(false);
			}, 4000);
		} else {
			convertLeadToPurchaser(lead.leadsKey);
			closeConfirmation('startAgreement');
			history.push({
				pathname: `/agreement/${lead.leadsKey}`,
				state: {
					from: 'Leads',
				},
			});
		}
	};

	const handleScheduleMeeting = () => {
		openModal('scheduleMeeting');
	};

	const handleVideoCall = (e) => {
		var detailsForCall = {
			thisEmail: appointmentDetails?.users[0]?.email,
			thisName: appointmentDetails?.appointmentName,
			thisAppointmentCode: appointmentDetails?.appointmentID,
			thisAppointmentTime: appointmentDetails?.timeOfAppointment,
			thisUserType: currentUserDetails?.userType,
			thisPhone: appointmentDetails?.users[0]?.phoneNumber,
			thisUID: currentUserDetails?.uid,
			shortCode: appointmentDetails?.shortCode,
		};

		appointmentDetails &&
			history.push({
				pathname: '/videocall',
				state: {
					detail: detailsForCall,
				},
			});

		closeModal('leadDetails');
	};

	var buttonList = [
		{
			name: 'Discard',
			action: () => {
				handleDiscard();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleConfirm();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	const validateCoBrokerNumOfLots = () => {
		if (coBrokerInfo.numberOfLotsAllowed) {
			if (purchasers.length >= Number(coBrokerInfo.numberOfLotsAllowed)) {
				return false;
			} else {
				return true;
			}
		} else {
			return true;
		}
	};

	return (
		<div className={styles.leadDetailsModal}>
			<CustomAlerts
				alertType={'error'}
				alertMsg={snackbarMessage}
				snackbar={snackbar}
				setSnackbar={setSnackbar}
			/>
			<Modal
				show={showModal}
				button={handleStartAgreement}
				close={() => closeModal('leadDetails')}
				wrapperWidth='90%'
				wrapperMax={850}
				leadStyling={true}
			>
				{lead && (
					<>
						<div className={styles.rowHeaderWrapper}>
							<div className={styles.rowHeaderSection}>
								<div className={styles.rowTitleWrppaer}>
									<div className={styles.rowHeaderTitle}>
										<h2 className={styles.lead}>
											{`${lead.clientFName} ${lead.clientLName}`}
										</h2>
										<IconButton
											className={styles.edit_icon}
											aria-label='edit purchaser'
											onClick={(e) =>
												handleEditLead(e, lead?.leadId)
											}
										>
											<Edit />
										</IconButton>
									</div>
									<StripeProcessing
										selected={leadById}
										openVerificationModal={() =>
											openVerificationModal(
												leadById,
												leadById?.leadId
											)
										}
										hide={togglIdentification}
										handleTogleStripe={() =>
											setTogglIdentification(false)
										}
										isLead={true}
									/>
								</div>

								{lead?.sentEmail === 1 &&
									appointmentDetails && (
										<MeetingStatus
											leadId={lead?.leadId}
											appointment={appointmentDetails}
										/>
									)}
							</div>
							<div className={styles.rowHeaderSection}>
								<div className={styles.leadDetails}>
									{lead.email} | {lead.leadsPhoneNumber}
								</div>
								<div className={styles.rowHeaderSchedule}>
									{lead?.sentEmail === 1 ? (
										<div
											className={
												styles.header_meeting_btn
											}
											onClick={() => handleVideoCall()}
										>
											<Videocam />
											<span>Join Meeting</span>
										</div>
									) : (
										<>
											<div
												className={
													styles.header_meeting_btn
												}
												onClick={() =>
													handleScheduleMeeting()
												}
											>
												<CalendarToday />
												<span>Schedule Meeting</span>
											</div>
										</>
									)}
								</div>
							</div>
						</div>

						<div className={styles.rowContentsWrapper}>
							<div className={styles.rowStripeContent}>
								<StripeSection
									hide={togglIdentification}
									selected={leadById}
									openVerificationModal={() =>
										openVerificationModal(
											leadById,
											leadById?.leadId
										)
									}
								/>
								<center>
									{!togglIdentification && (
										<IconButton
											className={styles.edit_icon}
											aria-label='close identification'
											onClick={() =>
												setTogglIdentification(true)
											}
										>
											<ExpandLessIcon />
										</IconButton>
									)}
								</center>
							</div>
							<div className={styles.row}>
								<div className={styles.rowContentWrapper}>
									<InfoOutlined />
									<span>Deal Specifications</span>
								</div>
								<hr />
								<Grid
									container
									className={styles.row}
									spacing={2}
									justifyContent='space-between'
								>
									<Grid item>
										<span className={styles.title}>
											Source
										</span>
										<p>{lead.reference || '---'}</p>
									</Grid>
									<Grid item>
										<span className={styles.title}>
											Desired Size
										</span>
										{lead?.desiredSize?.minVal ? (
											<p>
												{lead?.desiredSize?.minVal}sqft
												~
												{lead?.desiredSize?.maxVal ===
												2000
													? 'Unlimited'
													: lead?.desiredSize?.maxVal}
												sqft
											</p>
										) : (
											<p>---</p>
										)}
									</Grid>
									<Grid item>
										<span className={styles.title}>
											Desired Price
										</span>
										{lead?.desiredPrice?.minVal ? (
											<p>
												$
												{numberWithCommas(
													lead?.desiredPrice?.minVal
												)}
												~ $
												{lead?.desiredPrice?.maxVal ===
												1100000
													? '50,000,000+'
													: numberWithCommas(
															lead?.desiredPrice
																?.maxVal
													  )}
											</p>
										) : (
											<p>---</p>
										)}
									</Grid>
									<Grid item>
										<span className={styles.title}>
											Agent Assigned
										</span>
										<p>{salesAgentName || '---'}</p>
									</Grid>
									<Grid item>
										<span className={styles.title}>
											Mortgage
										</span>
										<p>
											{lead.mortgageQualification === 'no'
												? 'Not qualified'
												: 'Pre-qualified'}
										</p>
									</Grid>
								</Grid>
							</div>
						</div>
					</>
				)}
				<div className={styles.row}>
					<div
						className={styles.button}
						onClick={() => handleStartAgreement()}
					>
						Start Agreement
					</div>
				</div>
			</Modal>
			{/* //open, handleClose, title, dialogContent, buttonList  */}
			<ConfirmationComponent
				open={confirmation?.startAgreement}
				handleClose={handleDiscard}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={buttonList}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	confirmation: state.confirmation,
	appointmentDetails: state.leads.appointmentDetailByLeadId,
	currentUserDetails: state.signIn,
	leadById: state.leads.leadById,
	leads: state.leads.leads,
	purchasers: state.purchasers.purchaserList,
});

export default connect(mapStateToProps, {
	closeModal,
	openModal,
	getLeadById,
	setConfirmation,
	closeConfirmation,
	convertLeadToPurchaser,
	getAppointment,
	resetAgreement,
})(LeadDetailsModal);
